(function () {
  'use strict';

  var DIALOG_SEL = '.blz_storeSelector__section[role="dialog"]';
  var OVERLAY_SEL = '.blz_storeSelector__overlay';
  var patched = new WeakSet();
  var lastTrigger = null;

  function patchDialog(dialog) {
    if (patched.has(dialog)) return;
    patched.add(dialog);

    var closeBtn = dialog.querySelector('.blz_storeSelector__action_close');
    if (closeBtn) {
      closeBtn.setAttribute('type', 'button');
      if (!closeBtn.getAttribute('aria-label')) {
        closeBtn.setAttribute('aria-label', 'Close country selector');
      }
    }

    dialog.querySelectorAll('.blz_storeSelector__section-img').forEach(function (el) {
      el.removeAttribute('role');
      el.removeAttribute('aria-modal');
      el.removeAttribute('aria-label');
      el.setAttribute('role', 'presentation');
      el.removeAttribute('tabindex');
    });

    dialog.querySelectorAll('.blz-container-img').forEach(function (img) {
      if (!img.hasAttribute('alt')) img.setAttribute('alt', '');
      img.setAttribute('role', 'presentation');
    });

    dialog.querySelectorAll('.blz_storeSelector__icon_close, .blz_storeSelector__icon_down').forEach(function (i) {
      i.setAttribute('aria-hidden', 'true');
    });

    var titleStrong = dialog.querySelector('.blz_storeSelector__title strong, .blz_storeSelector__message strong');
    if (titleStrong && !titleStrong.hasAttribute('role')) {
      titleStrong.setAttribute('role', 'heading');
      titleStrong.setAttribute('aria-level', '2');
    }

    // WCAG 4.1.3 Status Messages: announce the geo-suggestion banner to AT
    // when it appears, without stealing focus. role="status" maps to a polite
    // live region per ARIA spec, matching the message's informational nature.
    dialog.querySelectorAll('.blz_storeSelector__message').forEach(function (el) {
      if (!el.hasAttribute('role')) el.setAttribute('role', 'status');
      if (!el.hasAttribute('aria-live')) el.setAttribute('aria-live', 'polite');
      if (!el.hasAttribute('aria-atomic')) el.setAttribute('aria-atomic', 'true');
    });

    var cancel = dialog.querySelector('.blz_storeSelector__cancel_cta');
    if (cancel && cancel.tagName !== 'BUTTON') {
      cancel.setAttribute('role', 'button');
      cancel.setAttribute('tabindex', '0');
      cancel.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          cancel.click();
        }
      });
    }

    trapFocus(dialog);
  }

  function getFocusable(root) {
    var sel = 'button:not([disabled]), [href], select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"]), [role="button"]:not([disabled])';
    return Array.from(root.querySelectorAll(sel)).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  function trapFocus(dialog) {
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var btn = dialog.querySelector('.blz_storeSelector__action_close');
        if (btn) btn.click();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusables = getFocusable(dialog);
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function moveFocusIn(dialog) {
    lastTrigger = document.activeElement;
    var focusables = getFocusable(dialog);
    if (focusables.length > 0) focusables[0].focus();
  }

  function restoreFocus() {
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function checkForDialog() {
    var dialog = document.querySelector(DIALOG_SEL);
    if (dialog) {
      patchDialog(dialog);
      var overlay = document.querySelector(OVERLAY_SEL);
      if (overlay && getComputedStyle(overlay).display !== 'none' && !overlay.dataset.blzA11yFocused) {
        overlay.dataset.blzA11yFocused = '1';
        moveFocusIn(dialog);
      }
    } else {
      if (lastTrigger) restoreFocus();
    }
  }

  function init() {
    checkForDialog();
    var observer = new MutationObserver(function () {
      checkForDialog();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
